import { NgModule } from '@angular/core';
import { ChronosSharedModule } from 'chronos-shared';
import { SpeedMonitorHostComponent } from './speed-monitor-host/speed-monitor-host.component';

@NgModule({
  declarations: [SpeedMonitorHostComponent],
  imports: [ChronosSharedModule]
})
export class SpeedMonitorModule {}
